import React, { useEffect, useState } from "react";
import { SelectUi } from "../../../ui/SelectUi";
import { get_estados_programacion_tejido } from "../../../../actions/produccion";

export const EstadoProgramacionSelect = ({ ...restProps }) => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    const OnLoad = async () => {
      const data = await get_estados_programacion_tejido();
      setItems(data);
    };
    OnLoad();
    return () => {
      setItems([]);
    };
  }, []);

  return <SelectUi data={items} {...restProps} />;
};
